export const getUserNameForAvatar = (firstName, lastName) => {
  let fName = firstName.split(" ");
  if (fName.length >= 3) {
    return extractFirstLettre(fName, 3);
  } else {
    let lName = lastName.split(" ");
    return extractFirstLettre(fName.concat(lName), 3);
  }
};

function extractFirstLettre(arrayStr, length) {
  let result = "";
  for (let i = 0; i < arrayStr.length; i++) {
    if (arrayStr[i]) {
      result += arrayStr[i].substring(0, 1);
    }
  }
  return result.toUpperCase();
}

export const inIframe = () => {
  return window.location !== window.parent.location;
};

export const postMessage = (msg, evt) => {
  window.parent.postMessage(
    {
      message: msg,
      event: evt
    },
    "*"
  );
};



// WEBPACK FOOTER //
// ./src/utils/user.js